// client/src/pages/About.js
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay },
});

export default function About() {
  return (
    <div className="min-h-screen bg-[#05040f] text-white px-6 md:px-20 py-16">
      <motion.div
        {...fadeUp(0.05)}
        className="max-w-4xl mx-auto text-center mb-10"
      >
        <Link to="/" className="inline-flex items-center justify-center gap-3">
          <img src="/logo.png" alt="smsorbit" className="w-10 h-10 rounded-xl" />
          <span className="text-xl font-bold tracking-wide">SMSOrbit</span>
        </Link>
        <h1 className="mt-6 text-3xl md:text-4xl font-bold">
          About <span className="text-purple-400">SMSOrbit</span>
        </h1>
        <p className="mt-3 text-gray-400 text-sm md:text-base max-w-2xl mx-auto">
          Smart, fully–automated SMM panel built for agencies, resellers and
          brands that care about quality.
        </p>
      </motion.div>

      <motion.div
        {...fadeUp(0.15)}
        className="max-w-4xl mx-auto rounded-3xl bg-[#090912] border border-white/5 p-8 md:p-10 space-y-4 text-sm md:text-base text-gray-200 leading-relaxed"
      >
        <p>
          <strong>SMSOrbit SMM Panel</strong> is focused on one thing: delivering
          reliable social media growth with a smooth, modern experience. We
          treat client satisfaction as our top priority – every feature in the
          panel is designed to save time, increase transparency and help you
          scale.
        </p>
        <p>
          Our team constantly tracks the latest platform changes and updates our
          services to keep performance high. We work with trusted providers and
          route your orders intelligently so you always get the best balance
          between speed, quality and price.
        </p>
        <p>
          Whether you are a small business, creator, agency or large reseller,
          SMSOrbit gives you a powerful dashboard to manage everything in one
          place – orders, balance, tickets, mass orders and API integration.
        </p>
        <p>
          With{" "}
          <span className="text-purple-300 font-semibold">
            24/7 automation, smart routing and account-level analytics
          </span>
          , we help you grow faster while staying in full control of your
          campaigns.
        </p>
      </motion.div>
    </div>
  );
}
